export default class UserValidationRule {
  public readonly REQUIRED = 'E-mail is required'
  public readonly VALID_EMAIL = 'E-mail must be valid'
  public readonly EMAIL_MAX_LENGTH = 50
  public readonly DESCRIPTION_MAX_LENGTH = 500

  public emailRules: Array<object> = [
    (v: string) => !!v || this.REQUIRED,
    (v: string) => /.+@.+/.test(v) || this.VALID_EMAIL,
    (v: string) => (v && v.length <= this.EMAIL_MAX_LENGTH) || `Email must ${this.EMAIL_MAX_LENGTH} characters or less.`,
  ]
  public descriptionRules: Array<object> = [
    (v: string) => !v || v.length <= this.DESCRIPTION_MAX_LENGTH || `Description must ${this.DESCRIPTION_MAX_LENGTH} characters or less.`,
  ]

  constructor() {}
}
